import {CustomDialog} from "../DialogCustom";
import {Box} from "@mui/material";
import React from "react";

export const LoadingDialog = ({label=''}) => (
  <CustomDialog>
    <Box className="text-center">
      <i className="fas fa-sync fa-spin text-ptTeal text-5xl"/>
      <p className="text-gray-700 mt-4 text-lg font-semibold">
        {label}
      </p>
    </Box>
  </CustomDialog>
)
